import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './App.css';


let root = createRoot(document.getElementById('root'));
root.render(<App />);
